var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExamLightGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1453_12886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7146 0.857422H2.57171C2.11705 0.857422 1.68102 1.03803 1.35952 1.35952C1.03803 1.68102 0.857422 2.11705 0.857422 2.57171V21.4289C0.857422 21.8835 1.03803 22.3195 1.35952 22.641C1.68102 22.9625 2.11705 23.1431 2.57171 23.1431H18.0003C18.4549 23.1431 18.891 22.9625 19.2125 22.641C19.534 22.3195 19.7146 21.8835 19.7146 21.4289V13.7146",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.857422 18H19.7146",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5.14355H9.42857",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9.42871H7.71429",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4182 12.8674L10.2754 13.7931L11.1325 8.58165L18.384 1.3645C18.5433 1.20383 18.7329 1.07629 18.9418 0.989262C19.1507 0.90223 19.3748 0.857422 19.6011 0.857422C19.8274 0.857422 20.0515 0.90223 20.2604 0.989262C20.4693 1.07629 20.6589 1.20383 20.8182 1.3645L22.6354 3.18165C22.7965 3.34078 22.9244 3.5303 23.0117 3.73924C23.099 3.94817 23.1439 4.17235 23.1439 4.39879C23.1439 4.62523 23.099 4.84941 23.0117 5.05834C22.9244 5.26728 22.7965 5.4568 22.6354 5.61593L15.4182 12.8674Z",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1453_12886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamLightGreyIcon);
export default __webpack_public_path__ + "static/media/exam-light-grey-icon.92f502b77c4410ed70b84d1414f713b1.svg";
export { ForwardRef as ReactComponent };